import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore } from './stores/authStore'

// Pages
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import JobsPage from './pages/JobsPage'
import JobDetailPage from './pages/JobDetailPage'
import NewJobPage from './pages/NewJobPage'
import MyJobsPage from './pages/MyJobsPage'
import MyWorkPage from './pages/MyWorkPage'
import SubmitWorkPage from './pages/SubmitWorkPage'
import LeaderboardPage from './pages/LeaderboardPage'
import ProfilePage from './pages/ProfilePage'
import WalletPage from './pages/WalletPage'
import NotificationsPage from './pages/NotificationsPage'
import ProductsPage from './pages/ProductsPage'
import ProductDetailPage from './pages/ProductDetailPage'
import NewProductPage from './pages/NewProductPage'
import MyProductsPage from './pages/MyProductsPage'
import AdminDashboardPage from './pages/admin/AdminDashboardPage'
import AdminUsersPage from './pages/admin/AdminUsersPage'
import AdminJobsPage from './pages/admin/AdminJobsPage'
import AdminProductsPage from './pages/admin/AdminProductsPage'
import AdminTransactionsPage from './pages/admin/AdminTransactionsPage'
import SettingsPage from './pages/SettingsPage'

// Layouts
import DashboardLayout from './components/layout/DashboardLayout'
import AuthLayout from './components/layout/AuthLayout'
import ProtectedRoute from './components/layout/ProtectedRoute'
import AdminRoute from './components/layout/AdminRoute'

export default function App() {
  const initialize = useAuthStore((state) => state.initialize)

  useEffect(() => {
    initialize()
  }, [initialize])

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />

      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
      </Route>

      {/* Dashboard routes with sidebar */}
      <Route element={<DashboardLayout />}>
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/jobs/:id" element={<JobDetailPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:id" element={<ProductDetailPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/jobs/new" element={<NewJobPage />} />
          <Route path="/my-jobs" element={<MyJobsPage />} />
          <Route path="/my-work" element={<MyWorkPage />} />
          <Route path="/my-work/submit/:jobId" element={<SubmitWorkPage />} />
          <Route path="/products/new" element={<NewProductPage />} />
          <Route path="/my-products" element={<MyProductsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>

        {/* Admin routes */}
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/jobs" element={<AdminJobsPage />} />
          <Route path="/admin/products" element={<AdminProductsPage />} />
          <Route path="/admin/transactions" element={<AdminTransactionsPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
